import { MdCreateNewFolder, MdEdit } from 'react-icons/md';
import { Button, Icon, Modal, ModalFooter } from '@nbirl/nbi-common-ui-libs';
import { FormikConfig } from 'formik';

import { FolderNameForm, FolderNameFormValue } from './folder-name-form';

type FolderNameModalProps = {
  mode?: 'edit' | 'create';
  modalHeading: string;
  onSubmit: FormikConfig<FolderNameFormValue>['onSubmit'];
  isOpen: boolean;
  isLoading?: boolean;
  onModalClose: () => void;
  initialName?: string;
};

export const FolderNameModal = ({
  mode = 'create',
  modalHeading,
  onSubmit,
  isOpen,
  isLoading,
  onModalClose,
  initialName,
}: FolderNameModalProps) => (
  <Modal
    isOpen={isOpen}
    heading={modalHeading}
    headingIcon={
      <Icon icon={mode === 'edit' ? <MdEdit /> : <MdCreateNewFolder />} />
    }
    onDismiss={onModalClose}
  >
    <FolderNameForm onSubmit={onSubmit} initialName={initialName}>
      <ModalFooter>
        <Button variant="outline" onClick={onModalClose}>
          Cancel
        </Button>
        <Button type="submit" isPending={isLoading}>
          {mode === 'edit' ? 'Save' : 'Add'}
        </Button>
      </ModalFooter>
    </FolderNameForm>
  </Modal>
);
